<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
		<br>
		<div class="col-lg-12">
			<div class="card card-danger card-outline collapsed-card">
		<div class="card-header">
			<div class="card-title">Data Filters</div>
			<div class="card-tools">
      <!-- Collapse Button -->
      <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>
    </div>
		</div>
		<div class="card-body">
			<div class="col-lg-12 float-left">
				<div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <span class="right badge badge-secondary">Pick InterCompany:</span>
                            <v-select v-model="params.inter_company" :options="inter_companies" :reduce="inter_companies => inter_companies.code" placeholder="Select Inter Company" label="name"></v-select>
                        </div>
                    </div>
					<div class="col-sm-4">
						<div class="form-group">
                            <span class="right badge badge-secondary">Created |From Date:</span>
								<input type="date" class="form-control" v-model="params.from_date" placeholder="From date">
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
                            <span class="right badge badge-secondary">Created |To Date:</span>
								<input type="date" class="form-control" v-model="params.to_date" placeholder="To date">
							</div>
					</div>
<!--                    <div class="col-sm-4">-->
<!--                        <div class="form-group">-->
<!--                            <select class="form-control" v-model="params.branch">-->
<!--                                <option v-for="branch in branches" :value="branch.branch_code">{{branch.branch}}</option>-->
<!--                            </select>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col-sm-4">-->
<!--                        <div class="form-group">-->
<!--                            <select class="form-control" v-model="params.branch">-->
<!--                                <option v-for="vendor in vendors" :value="branch.branch_code">{{branch.branch}}</option>-->
<!--                            </select>-->
<!--                            <v-select v-model="params.vendor" type="text" label="fullname" :options="branches" :reduce="branches => branches.branch_code" placeholder="Select Branch" :value="branches => branches.branch_code"></v-select>-->

<!--                        </div>-->
<!--                    </div>-->
                    <div class="col-sm-4">
                        <div class="form-group">
                            <span class="right badge badge-secondary">Vendor Name:</span>
                            <input class="form-control" placeholder="Enter a vendor name" v-model="params.vendorname" type="text">
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <span class="right badge badge-secondary">Vendor Code:</span>
                            <input class="form-control" placeholder="Enter a vendor code" v-model="params.vendorcode" type="text">
                        </div>
                    </div>
					<div class="col-sm-4">
						<div class="form-group">
                            <span class="right badge badge-secondary">Phone:</span>
								<input class="form-control" placeholder="Enter a phone number" v-model="params.phone" type="number" min="1000000000">
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
                            <span class="right badge badge-secondary">SAP Doc No:</span>
								<input class="form-control" placeholder="Enter SAP Doc Number" v-model="params.sapdocno" type="text">
							</div>
					</div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <span class="right badge badge-secondary">SAP Doc Entry:</span>
                            <input class="form-control" placeholder="Enter SAP Doc Entry" v-model="params.sapdocentry" type="text">
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <span class="right badge badge-secondary">SAP Status:</span>
                            <select class="form-control" v-model="params.sap_pushed">
                                <option value="1">Success</option>
                                <option value="0">Pending</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <span class="right badge badge-secondary">Document Status:</span>
                            <select class="form-control" v-model="params.status">
                                <option value="1">OPEN</option>
                                <option value="0">CLOSED</option>
                            </select>
                        </div>
                    </div>
					<div class="col-sm-4">
						<div class="form-group">
                            <span class="right badge badge-secondary">Purchase Request Number:</span>
								<input class="form-control" placeholder="Enter Purchase Request Number" v-model="params.request_id" type="text">
							</div>
					</div>
					<div class="col-sm-4">
                        <span class="right badge badge-secondary">Purchase Order Number:</span>
						<div class="form-group"><input class="form-control" placeholder="Enter Purchase Order No." v-model="params.order_id" type="text">
								</div>
					</div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <span class="right badge badge-secondary">APX Bill No:</span>
                            <input class="form-control" placeholder="Enter SAP Doc Entry" v-model="params.apxbillno" type="text">
                        </div>
                    </div>
				</div>
				<div class="row">
					<div class="col-sm-4">
						<div class="form-group">
								<button class="btn btn-primary" style="width:100% !important;"  @click="getOrders('/api/getInterCompanyPurchaseOrders')">Search</button>
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<button class="btn btn-success" style="width:100% !important;" @click="exportOrders">Export</button>
							</div>
					</div>
					<div class="col-sm-4">
						<div class="form-group">
								<button class="btn btn-danger" style="width:100% !important;" @click="reset">Reset</button>
							</div>
					</div>
				</div>
			</div>
		</div>
			</div>
		</div>
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
    <div class="row">
        <div class="col-md-9">
            <h5>DATASHEET V1.0</h5>
            <h5>Total Entries: {{pagination.total}}</h5>
        </div>
        <div class="col-md-3">
            <pagination :pagination="pagination"
                        @prev="getAllDeliveryCommitments(pagination.prevPageUrl)"
                        @next="getAllDeliveryCommitments(pagination.nextPageUrl)"
            ></pagination>
        </div>
    </div>
	<div class="card card-danger card-outline">
		<div class="card-body overflow-auto">
				<table class="table table-hover table-striped table-bordered">
						<thead class="thead-dark">
							<tr>
								<th scope="col">SAP Doc No.</th>
                                <th scope="col">Date</th>
                                <th scope="col">Branch</th>
                                <th scope="col">Request No.</th>
                                <th scope="col">Created By</th>
								<th scope="col">Vendor Info</th>
								<th scope="col">PO Value</th>
                                <th scope="col">Fulfilled Value</th>
                                <th scope="col">PO Status</th>
								<th scope="col">View</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="order in orders">
								<td>
                                    <p>SAP:{{order.sap_doc_num}}</p>
                                    <p>PO:{{order.id}}</p>
                                    <p>APX: {{order.apx_bill_no}}</p>

                                </td>
                                <td>{{order.created_at | smallDate}}</td>
                                <td>{{order.ship_to}}</td>
                                <td><button class="btn btn-secondary" style="width:100% !important;"  @click="viewPurchaseRequest(order)">{{order.purchase_request_id}}</button></td>

                                <td>{{order.created_by.user_detail}}</td>
								<td>
                                    <p>{{order.customer_name}}</p>
                                    <p>{{order.phone_number}}</p>
                                </td>
								<td>{{order.doc_total}}</td>
                                <td>{{order.grpo_total}}</td>
                                <td>
                                    <span v-if="order.status==1" class="badge badge-success"><b>OPEN</b></span>
                                    <span v-if="order.status==0" class="badge badge-danger"><b>CLOSED</b></span>
                                </td>
								<td>
									<p v-if="order.sap_doc_num ==null"><button class="btn btn-primary" @click="viewPurchaseRequest(order)">Edit</button></p>
                                    <p v-if="order.sap_doc_num !=null"><button class="btn btn-primary" style="width:100% !important;" @click="viewOrder(order)"><i class="fa fa-search"></i> View</button></p>
                                    <p v-if="order.status ==1"><button class="btn btn-warning" style="width:100% !important;" @click="addGRPO(order)"><i class="fa fa-plus"></i> Add GRPO</button></p>
<!--									<button class="btn btn-primary" v-if="order.sap_doc_num !=null" @click="viewPO(order)">Print PO</button>-->
<!--									<button class="btn btn-danger" v-if="order.sap_doc_num ==null" @click="cancelOrderPrompt(order)">Cancel Order</button>-->
								</td>
							</tr>
						</tbody>
				</table>
    </div>
    <div class="card-footer">
			<pagination :pagination="pagination"
       	@prev="getOrders(pagination.prevPageUrl)"
        @next="getOrders(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->
<!--					<div class="modal" tabindex="-1" role="dialog" id="cancelOrderModal">-->
<!--                <div class="modal-dialog" role="document">-->
<!--                    <div class="modal-content">-->
<!--                        <div class="modal-body">-->
<!--                            <h3>-->
<!--                                Are you sure you want to cancel the order?-->
<!--                            </h3>-->
<!--                        </div>-->
<!--                        <div class="modal-footer">-->
<!--                           <button class="btn btn-success" @click="cancelOrder">-->
<!--                                Yes-->
<!--                            </button>-->
<!--                            <button class="btn btn-danger" data-dismiss="modal">No</button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->


<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

     		components: {pagination: Pagination},

        created(){
            this.getInterCompanies();
        	this.getOrders();
        	// this.getDeliveryModes();
        	this.getVendors();
    			// this.getBranches();
        },

        data(){
        	return{
        		orders: [],
                inter_companies:[],
        		results: '',
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},

         		params: new Form({
         			sap_pushed: null,
         			customer_type: null,
         			delivery_mode: null,
                    status: null,
                    inter_company:null,
         			phone: null,
         			sapdocno: null,
                    sapdocentry: null,
         			vendorcode: null,
                    vendorname: null,
         			from_date: null,
         			to_date: null,
         			source: null,
         			order_id: null,
                    request_id: null,
         			payment_mode: null,
         			finance_mode: null,
         			payment_status: null,
         			branch: null,
                    apxbillno: null,
         		}),
         		delivery_modes: [],
         		pms: [],
         		fms: [],
         		branches: [],
         		cancelorder: {},
                vendors:[]
        	}
        },

        methods: {
            getInterCompanies(){
                axios.post("/api/getInterCompanies")
                    .then(response => {
                        this.inter_companies = response.data;
                    })
            },
        	getPMS() {
						axios.post("/api/getSAPPaymentModes").then((response) => {
						  this.pms = response.data;
						});
					},

					getBranches(){
        		if(this.usertype == 'zonal-manager'){
        			axios.post("/api/getZonalManagerBranches")
        			.then(response => {
        				this.branches = response.data;
        			});
        		}
        	},

            getVendors() {
                axios.post("/api/getSAPVendors")
                    .then((response) => {
                    this.vendors = response.data;
                });
            },

					getFMS() {
						axios.post("/api/getSAPFinanceModes").then((response) => {
						  this.fms = response.data;
						});
					},

        	getOrders(url="/api/getInterCompanyPurchaseOrders"){
        		axios.post(url, {results: this.results, params: this.params})
		      	.then(response => {
		      		this.orders = response.data.data.data;
		      		this.configPagination(response.data.data);
		      	})
		      },

		      exportOrders(){
        		axios.post("/api/exportSaleOrders", {params: this.params})
		      	.then(response => {
		      		var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        			saveAs(response.data, "sale_orders.xlsx");
		      	});
		      },

		      getDeliveryModes(){
        		axios.post("/api/getDeliveryModes")
        		.then(response => {
        			this.delivery_modes = response.data;
        		});
        	},

		      configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},

    			reset(){
    				this.params.reset();
    				this.getOrders();
    			},

    			viewOrder(order){
                    let route = this.$router.resolve('/purchasing/po_print/'+order.id+'/'+order.purchase_request_id);
                    // let route = this.$router.resolve('/link/to/page'); // This also works.
                    window.open(route.href, '_blank');
    			},

                addGRPO(order){
                    let route = this.$router.resolve('/create-grpo/'+order.id);
                    // let route = this.$router.resolve('/link/to/page'); // This also works.
                    window.open(route.href, '_blank');
                },

    			viewInvoice(order){
                    let route = this.$router.resolve('/purchasing/po_print/'+order.id+'/'+order.purchase_request_id);
                    // let route = this.$router.resolve('/link/to/page'); // This also works.
                    window.open(route.href, '_blank');
    			},

                viewPurchaseRequest(order){
                    let route = this.$router.resolve('/create-purchase-request/'+order.purchase_request_id);
                    // let route = this.$router.resolve('/link/to/page'); // This also works.
                    window.open(route.href, '_blank');
                },

    			cancelOrderPrompt(order){
    				this.cancelorder = order;
    				$("#cancelOrderModal").modal("show");
    			},

    			// cancelOrder(){
    			// 	axios.post("/api/cancelSaleOrder", {id: this.cancelorder.id, gatepass: this.cancelorder.gatepass_id, draft: this.cancelorder.draft_order_id})
    			// 	.then(response => {
    			// 		if(response.data == 1){
		  		// 			toast.fire({
		  		// 				icon: 'success',
		  		// 				title: 'Sale Order Cancelled'
		  		// 			});
		  		// 			this.getOrders();
		  		// 		}
		  		// 		else{
		  		// 			toast.fire({
		  		// 				icon: 'success',
		  		// 				title: 'Sale Order Cancelled'
		  		// 			});
		  		// 			this.getOrders();
		  		// 		}
    			// 	})
    			// 	.catch(() => {
    			// 		toast.fire({
    			// 			icon:'error',
    			// 			title: 'Failed!'
    			// 		});
    			// 	});
    			// }
        }
    }
</script>
